const stripEmpty = <T extends object>(value: T) => {
  return Object.fromEntries(Object.entries(value).filter(([, v]) => v));
};

export default stripEmpty;
